import { PERSIST_REFRESH_TOKEN, TOKEN_EXPIRY_SKEW_MS } from './config';
import { TAuthTokens } from './types';

let tokens: TAuthTokens | null = null;

const REFRESH_TOKEN_STORAGE_KEY = 'eas-cc-rt';

const readPersistedRefreshToken = (): string | null => {
	if (!PERSIST_REFRESH_TOKEN) return null;
	try {
		return window.localStorage.getItem(REFRESH_TOKEN_STORAGE_KEY);
	} catch {
		return null;
	}
};

const writePersistedRefreshToken = (refreshToken: string | null): void => {
	if (!PERSIST_REFRESH_TOKEN) return;
	try {
		if (refreshToken) window.localStorage.setItem(REFRESH_TOKEN_STORAGE_KEY, refreshToken);
		else window.localStorage.removeItem(REFRESH_TOKEN_STORAGE_KEY);
	} catch {
		/* empty */
	}
};

export const tokenStore = {
	get: (): TAuthTokens | null => tokens,

	getAccessToken: (): string | null => tokens?.accessToken ?? null,

	getRefreshToken: (): string | null => tokens?.refreshToken ?? readPersistedRefreshToken(),

	set: (next: TAuthTokens): void => {
		tokens = next;
		writePersistedRefreshToken(next.refreshToken);
	},

	clear: (): void => {
		tokens = null;
		writePersistedRefreshToken(null);
	},

	isFresh: (skewMs: number = TOKEN_EXPIRY_SKEW_MS): boolean =>
		tokens !== null && tokens.expiresAt - skewMs > Date.now(),
};
